import React, { useEffect, useState } from "react";
import { DashboardNavbar } from "../headers/DashboardHeader";
import { Route, Switch, useHistory } from "react-router-dom";
import { Spinner } from "@material-tailwind/react";
import { privateRoutes } from "../../routes";
import { SidebarContent } from "../Sidebar/SidebarContent";
import { MobileSidebar } from "../Sidebar/MobileSidebar";

const DashboardContent = () => {
  const [routes, setRoutes] = useState<any[]>(privateRoutes);
  const history = useHistory();

  return (
    <>
      <div className="flex bg-gray-100 h-full w-[100vw]">
        <div className="w-80 h-screen hidden xl:flex">
          <SidebarContent />
        </div>
        <div className="m-0 md:m-2 lg:m-5 w-[100vw] overflow-x-auto overflow-y-auto">
        <div className="dashboard-container w-full   h-[95vh] px-4 lg:px-5 rounded-3xl transition-all lg:rounded-3xl md:rounded-3xl">
            <React.Suspense fallback={<Spinner />}>
              <Switch>
                {routes?.map((route, index) => (
                  <Route
                    path={route.layout + route.path}
                    component={route.component}
                    exact={route.exact}
                    key={index}
                  />
                ))}
              </Switch>
            </React.Suspense>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardContent;
